if (!customElements.get('preorder-swatch-tooltip')) {
  class PreorderSwatchTooltip extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-preorder-tooltip-trigger]');
      this.tooltip = this.querySelector('[data-preorder-tooltip]');
      this.dismissTimer = null;

      if (!this.trigger || !this.tooltip) return;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);

      this.trigger.addEventListener('click', this.onTriggerClick);
    }

    disconnectedCallback() {
      this.hide();
      this.trigger?.removeEventListener('click', this.onTriggerClick);
    }

    get isMobile() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }

    onTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.hasAttribute('open')) {
        this.hide();
        return;
      }

      this.show();

      if (this.isMobile) {
        clearTimeout(this.dismissTimer);
        this.dismissTimer = setTimeout(() => this.hide(), 3000);
      }

      document.addEventListener('pointerdown', this.onDocumentPointerDown);
    }

    onDocumentPointerDown(event) {
      if (this.contains(event.target)) return;
      this.hide();
    }

    show() {
      this.tooltip.hidden = false;
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    hide() {
      this.tooltip.hidden = true;
      this.removeAttribute('open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    }
  }

  customElements.define('preorder-swatch-tooltip', PreorderSwatchTooltip);
}
